module.exports = __webpack_public_path__ + "img/13-villas.9cdc8499.jpg";